import React from "react";
import { useNavigate } from "react-router-dom";
import { WhyChooseUsConstants } from "./WhyChooseUsConstants";
import "./WhyChooseUs.scss";
import whyChose from "../../../assets/images/whyChose.svg";

const WhyChooseUs: React.FC = () => {
    const navigate = useNavigate();
    const { whyChooseUs } = WhyChooseUsConstants;

    const handleButtonClick = (route: string) => {
        navigate(route);
    };

    return (
        <section className="why-choose-us">
            <div className="why-choose-us-container">
                <div className="why-choose-us-content">
                    <div className="why-choose-us-content-left">
                        <div className="why-choose-us-tag">
                            <img className="tag-icon-image" src={whyChooseUs.icon} alt="Fire icon" />
                            <span className="tag-text">{whyChooseUs.tag}</span>
                        </div>

                        <div className="why-choose-us-copy">
                            <h2 className="why-choose-us-title">
                                {(() => {
                                    const words = whyChooseUs.title.split(" ");
                                    const mid = Math.ceil(words.length / 2);

                                    return (
                                        <>
                                            <div className="title-first">
                                                {words.slice(0, mid).join(" ")}{" "}
                                            </div>
                                            <div className="title-second">
                                                {words.slice(mid).join(" ")}
                                            </div>
                                        </>
                                    );
                                })()}
                            </h2>
                            <p className="why-choose-us-tagline">
                                {whyChooseUs.tagline}
                            </p>
                            <p className="why-choose-us-description">
                                {whyChooseUs.description}
                            </p>
                            {/* <button
                            className="why-choose-us-button"
                            onClick={() => handleButtonClick(whyChooseUs.button.route)}
                        >
                            {whyChooseUs.button.text}
                        </button> */}
                        </div>
                    </div>


                    {/* Right Section - Images with Feature Tags */}
                    <div className="why-choose-us-visuals">
                        <img
                            src={whyChose}
                            alt="Why choose us"
                            className="why-choose-us-right-image"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;

